<template>
  <button class="button" :class="[type + '-btn', active ? '' : 'dark', light ? 'light' : '']" @click="$emit('btnEvent')">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: String,
    active: Boolean,
    light: Boolean
  }
}
</script>

<style lang="scss" scoped>
.button {
  color: #fff;
  text-transform: uppercase;
  @include flexrc;
  @include px2res(width, 237);
  @include px2res(height, 87);
  @include px2res(font-size, 34);
  // -webkit-text-stroke: 1px rgba(0, 0, 0, .3);
  transition: all .3s cubic-bezier(0.0,0.0,0.2,1);
}
.button:disabled {
  filter: grayscale(100%)
}
.confirm-btn {
  @include px2res(width, 296);
  @include px2res(height, 82);
  @include px2res(font-size, 40);
}
.refresh-btn {
  @include px2res(width, 206);
  @include px2res(height, 70);
  background-size: 100% auto;
}
.refresh-btn.dark {
  filter: grayscale(1);
}
.refresh-btn.light {
  animation: flash 1.2s ease-in-out infinite alternate;
}
.flip-btn {
  @include px2res(width, 269);
  @include px2res(height, 74);
  @include px2res(line-height, 78);
  @include px2res(font-size, 38);
  font-weight: bold;
}
.confirm-btn, .flip-btn {
  color:rgba(0, 0, 0, 1);
  font-weight: 500;
  font-style: italic;
  text-shadow: 3px 0 2px rgba(247, 205, 25, .8), -2px 0 2px rgba(247, 205, 25, .8);
}
@keyframes flash {
  0% {
    filter: brightness(.9);
  }
  100% {
    filter: brightness(1.4);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Button.vue